import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { createRef, useContext, useEffect, useState } from 'react';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
import { iWebFormField } from '../schema';
import { Box } from '@mui/system';
import { FieldsContext } from '../WebFormWorkspace';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export const WebFormDropDown1 = (props: {fieldConfig:iWebFormField,value?:any,editable?:any}) => {
    // const { fieldLabel = "",name="", placeholder = "Please Enter", isMandatory=false,fieldsOptions="Hi|Hello" } = props?.fieldConfig;
    const {fieldLabel,fieldOptions="",fieldDescription,isMandatory,id} = props.fieldConfig;
    const [menuOptions,setOptions] = useState<string[]>([]);
    const { errors } = useContext(FieldsContext);
    const errorMsg = errors?.[id];
    useEffect(()=>{
        console.log('WebFormDropDown_values',fieldOptions)
        if(fieldOptions && fieldOptions !== ""){
            let vals = fieldOptions.split('|')
            setOptions(vals)
        }
    },[fieldOptions])
    return (
        <div>
            <CustomFormLabel
                labelName={fieldLabel}
                isMandotary={isMandatory}
            />
            <FormControl error={!!errorMsg} sx={{ minWidth: "100%" }}>
                <Select
                    // value={props.value ? props.value : "please select"}
                    // defaultValue={props.value ? props.value : "please select"}
                    defaultValue={props.value ?? ""}
                    displayEmpty
                    // onChange={handleChange}
                    fullWidth={true}
                    name={`${id}`}
                    // displayEmpty
                    className='webform-dropdown'
                    // disabled={disabled || false}
                    readOnly={!props?.editable}
                    inputProps={{ 'aria-label': 'Without label' }}
                     MenuProps={{
                        PaperProps: {
                        sx: {
                            zIndex: '2147483647',
                            // position:'relative' // higher than your popup to appear on top
                        }
                        }
                    }}
                >
                    <MenuItem className='webform-dropdown-option' value="">Please Select</MenuItem>
                    {menuOptions.map((i:any,index:number)=>{
                            return <MenuItem className='webform-dropdown-option modal-content' key={index} value={i}>{i} </MenuItem>
                  
                   })}
                </Select>
                {errorMsg && <FormHelperText sx={{ color: "#ff0000 !important" }}>{errorMsg}</FormHelperText>}
                {(fieldDescription && fieldDescription.trim() !== "") && <FormHelperText className="helper-text-webform">{fieldDescription}</FormHelperText>}
            </FormControl>
        </div>
    )
}

// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@mui/material/Autocomplete';
// import { useEffect, useState } from 'react';
// import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
// import { iWebFormField } from '../schema';
// import { Box } from '@mui/system';

export const WebFormDropDown = (props: {idNamespace?:string, fieldConfig:iWebFormField,value?:any,editable?:any}) => {
    const {fieldLabel,fieldOptions="",fieldDescription,isMandatory,id} = props.fieldConfig;
    const [menuOptions,setOptions] = useState<string[]>([]);
    const [selectedValue, setSelectedValue] = useState<string | null>(null);
    const { errors, clearError } = useContext(FieldsContext);
    const errorMsg = errors?.[id];
    useEffect(() => {
        console.log('WebFormDropDown_values', fieldOptions);
        if(fieldOptions && fieldOptions !== "") {
            let vals = fieldOptions.split('|');
            setOptions(vals);
        }
    }, [fieldOptions]);

    useEffect(() => {
        // Set initial value if provided
        if (props.value) {
            setSelectedValue(props.value);
        }
    }, [props.value]);

    const handleChange = (event: any, newValue: string | null) => {
        setSelectedValue(newValue);
        if (newValue) {
            clearError?.(id);
        }
        // If you need to propagate the change to parent component, add callback here
    };

    return (
        <div>
            <CustomFormLabel
                labelName={fieldLabel}
                isMandotary={isMandatory}
            />
            <FormControl error={!!errorMsg} sx={{ minWidth: "100%" }}>
                <Autocomplete
                    options={menuOptions}
                    value={selectedValue}
                    onChange={handleChange}
                    fullWidth={true}
                    disabled={!props?.editable}
                    readOnly={!props?.editable}
                    // Use freeSolo if you want to allow custom values not in the list
                    // freeSolo={false}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            name={`${props.idNamespace ? props.idNamespace + '_' : ''}${id}`}
                            placeholder="Please select"
                            error={!!errorMsg}
                            helperText={errorMsg}
                            className='webform-dropdown-search'
                        />
                    )}
                    className='webform-dropdown'
                    // Optional: Customize the dropdown behavior
                    // You can also customize the PaperComponent if needed
                    PaperComponent={(props) => (
                        <div 
                            {...props}
                            style={{
                                ...props.style,
                                zIndex: 2147483647, // Higher z-index for dropdown
                                position: 'relative',
                                backgroundColor: 'white',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            }}
                        />
                    )}
                    // Optional: Clear button
                    // clearOnBlur={true}
                    // clearOnEscape={true}
                    // Optional: Handle input changes if freeSolo is true
                    // onInputChange={(event, newInputValue) => {
                    //     // Handle input changes if needed
                    // }}
                />
                {(fieldDescription && fieldDescription.trim() !== "") && 
                    <FormHelperText className="helper-text-webform">
                        {fieldDescription}
                    </FormHelperText>
                }
            </FormControl>
        </div>
    );
};